import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { siteRoutes } from './routes-config'
import { APP_INFO } from '@/data/app-info'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download Latest Version – Free APK ${APP_INFO.year}`,
			keywords: 'gb whatsapp download, gb whatsapp apk, gb whatsapp latest version, gbwhatsapp anti ban',
			description: 'Download GB WhatsApp latest version APK for Android. Free anti-ban mod with privacy controls, custom themes, and dual accounts.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhatts.net/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download',
		redirect: '/gb-whatsapp-latest-version',
	},
	...siteRoutes,
]

let routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else if (to.hash) {
				return new Promise((resolve) => {
					setTimeout(() => {
						resolve({ selector: to.hash, behavior: 'smooth' })
					}, 100)
				})
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
